import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgTelephone24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Telephone",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.103a3.254 3.254 0 0 0-3.25 3.25 3.254 3.254 0 0 0 3.25 3.25 3.254 3.254 0 0 0 3.25-3.25 3.254 3.254 0 0 0-3.25-3.25m0 5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.785 1.75 1.75-.785 1.75-1.75 1.75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.638 3H9.362C5.303 3 2 6.423 2 10.631v.21c0 .468.185.908.519 1.236.337.33.805.495 1.256.5.034-.002.071-.01.105-.01a3.82 3.82 0 0 0-.964 2.524v4.164A1.75 1.75 0 0 0 4.666 21h14.667a1.75 1.75 0 0 0 1.75-1.745v-4.164c0-.95-.354-1.837-.96-2.524.035.001.07.01.105.01h.049A1.737 1.737 0 0 0 22 10.84v-.209C22 6.423 18.697 3 14.638 3m4.945 16.255a.25.25 0 0 1-.25.25H4.667a.25.25 0 0 1-.25-.25v-4.164c0-.633.247-1.227.719-1.699l4.301-4.697h5.127l4.325 4.72a2.35 2.35 0 0 1 .695 1.676zm.917-8.415c0 .132-.104.24-.232.24a5.3 5.3 0 0 1-1.701-.275c-.015-.005-.03-.002-.045-.006l-3.074-3.356a.75.75 0 0 0-.554-.243H9.106a.75.75 0 0 0-.554.243l-3.069 3.353c-.008.002-.016 0-.024.002a6.5 6.5 0 0 1-1.709.283c-.097-.014-.151-.043-.179-.071a.23.23 0 0 1-.071-.17v-.209c0-3.383 2.629-6.135 5.862-6.135h5.276c3.232 0 5.862 2.752 5.862 6.135z"
}));

export { SvgTelephone24 as default };
//# sourceMappingURL=Telephone24.js.map
